<div class="flex flex-column gap pt-3">
    <app-multi-select-input
        id="expertiseCodes"
        label="service.serviceType.expertise"
        [staticOptions]="expertises()"
        [form]="form()"
        idField="code"
        valueKey="code"
        labelKey="code"
        [zIndex]="3000"
        (selectedValueChange)="expertisesChange.set($event || [])"
    >
    </app-multi-select-input>

    <app-multi-select-input
        [infiniteScroll]="procedureScroll()"
        [form]="form()"
        [id]="id"
        [label]="label"
        idField="code"
        valueKey="code"
        labelKey="description"
        filterBy="description,code,expertiseCode"
        [zIndex]="3000"
    >
        <ng-template #item let-item>
            <div class="flex-column">
                <div class="flex gap-small">
                    @if (item.code?.length) {
                        <span class="font-size-x-small text-secondary">{{ item.code }}</span>
                    }
                    @if (item.expertiseCode?.length) {
                        <span class="font-size-x-small text-secondary"> ({{ item.expertiseCode }})</span>
                    }
                </div>
                @if (item.description?.length) {
                    <app-strip-and-show
                        class="description font-size-x-small text-secondary" [length]="150"
                        [text]="item.description"
                    ></app-strip-and-show>
                }
            </div>
        </ng-template>

        <ng-template #selectedItems let-items>
            <div class="flex gap-2">
                @for (item of items; track item) {
                    <p-chip [label]="item.code"></p-chip>
                }
            </div>
        </ng-template>
    </app-multi-select-input>
</div>
